export default __webpack_public_path__ + "static/media/event4.64765685.jpg";